import {Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter} from '@angular/core';
import {ChangeDetectionStrategy} from "@angular/core";
import {ViewService} from "../../../services/common/view.service";


type Layout =
  "col" |
  "colStrong" |
  "colWeak" |

  "colWeak2" |
  // >may have 'edit' btn
  "colWeak2editable" |

  // can also take an array (vals)
  "colWeak3" |
  // colWeak3 + bug fix (white-space "reset")
  "colWeak3v2" |

  // has bool variation
  "colWeak4" |

  // *** row ***

  "row" |
  "rowWeak" |

  // row version of colWeak2
  "rowWeak2" |
  // >may have 'edit' btn
  "rowWeak2editable" |

  // row version of colWeak3v2 (w/ white-space "reset")
  // CANNOT take an array (NO vals)
  "rowWeak3" |
  // like rowWeak3 but 'val' param is innerHTML
  "rowWeak3_innerHTML" |
  // oneLiner version of colWeak3v2 (done w/ flex)
  "rowWeak3v2";



@Component({
  selector: 'app-output',
  templateUrl: './output.component.html',
  styleUrls: ['./output.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OutputComponent implements OnInit {



  // component args

  // custom css classes
  @Input() css: string;

  @Input() layout: Layout;
  DOMlayout: string;

  @Input() editable: boolean;

  @Input() lbl: string;
  @Input() prop: string;
  @Input() unit: string;

  @Input() val: boolean | string;
  @Input() valAlternatives: string[];
  @Input() val_isNum: boolean;
  @Input() vals: string[] = [];


  @Output() edit = new EventEmitter<any>();



  // listener

  listener = {
    view: null,
  };




  constructor(
    private cd: ChangeDetectorRef,
    // private navCtrl: NavController,
    // navParams can only be used in modals and popovers!
    // private navParams: NavParams,
    // private tdweb: TdwebService,
    // private dataService: DataService,
    // private popoverCtrl: PopoverController,
    // private alertCtrl: AlertController,
    // private modalCtrl: ModalController,
    // private api: ApiService,
    private view: ViewService,
    // private menuCtrl: MenuController,
  ) {}


  ngOnInit() {
    // console.log("ngOnInit()");

    //  -------------------------
    //  listeners:

    this.listenerView();
    //  -------------------------

    this.set_DOMlayout();
  }

  ngOnDestroy() {
    // console.log("ngOnDestroy()");

    //  -------------------------
    // disengage listeners:

    if (this.listener.view) {
      this.listener.view.unsubscribe();
    }
    //  -------------------------
  }




  /*myFunc() {
    console.log("myfunc", typeof this.val == 'number')
    return typeof this.val == 'number';
  }*/


  editEmit() {
    this.edit.emit();
  }


  set_DOMlayout() {
    if (!this.layout) {
      // default value
      this.layout = "col";
    }


    let layout: string;

    switch (this.layout) {
      case "colStrong":
        layout = "col-strong";
        break;

      case "colWeak":
        layout = "col-weak";
        break;

      case "colWeak2":
        layout = "col-weak-2";
        break;

      case "colWeak2editable":
        layout = "col-weak-2-editable";
        break;

      case "colWeak3":
        layout = "col-weak-3";
        break;

      case "colWeak3v2":
        layout = "col-weak-3-v2";
        break;

      case "colWeak4":
        layout = "col-weak-4";
        break;

      case "rowWeak":
        layout = "row-weak";
        break;

      case "rowWeak2":
        layout = "row-weak-2";
        break;

      case "rowWeak2editable":
        layout = "row-weak-2-editable";
        break;

      case "rowWeak3":
        layout = "row-weak-3";
        break;

      case "rowWeak3_innerHTML":
        layout = "row-weak-3-innerhtml";
        break;

      case "rowWeak3v2":
        layout = "row-weak-3-v2";
        break;

      default:
        layout = this.layout;
    }

    this.DOMlayout = layout;
    ViewService.updateView.next(undefined);
  }



  // listener

  listenerView() {
    this.listener.view = ViewService.updateView$.subscribe((obj?: any) => {
      // console.log("listener.view", obj);

      // this.zone.run(() => {

      this.view.pipeChanged++;
      this.cd.markForCheck();

      setTimeout(() => {
        this.cd.markForCheck();
      }, 250);

      // });
    });
  }





}
